import Vue from 'vue'
import VueRouter from 'vue-router'
import documentRoute from './document/index'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  component: () => import('@/views/Home.vue'),
}, ...documentRoute]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const default_title = '油柑网';
  let documentTitle = to.meta.title;
  let bodyColor = to.meta.bodyColor;
  document.title = documentTitle || default_title;
  if (bodyColor) {
    document.body.style.backgroundColor = bodyColor;
  } else {
    document.body.style.backgroundColor = '#f6f6f6';
  }
  //需要授权的页面
  next();
});

export default router